import React from 'react';
import { Link } from 'react-router-dom';
import './NoClearance.css';

function NoClearance() {
  return (
    <div className="no-clearance-page">
      <div className="no-clearance-background" style={{ backgroundImage: `url(/images/coming_soon_bg.png)`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div className="no-clearance-overlay"></div>
        <div className="no-clearance-content">
          <div className="lock-icon">🔒</div>
          <h1 className="no-clearance-title">Access Denied</h1>
          <p className="no-clearance-text">You don't have the proper clearance</p>
          <p className="no-clearance-subtext">This area is restricted.</p>
          <Link to="/" className="back-home-btn">Return Home</Link>
        </div>
      </div>
    </div>
  );
}

export default NoClearance;
